import React, {useRef} from 'react';
import Popup from "reactjs-popup";
import {useSelector} from "react-redux";

import useScroll from "ubs-framework/v2/hooks/useScroll";

import UEmployeeInfo from "../../../common/components/UEmployeeInfo";

const MembersList = React.memo((props) => {
    const popupRef = useRef(null);

    const _USERS = useSelector(e => e?.ats?.userObj || {});

    // visible-avatar count; the "+N" overflow must use this same limit (not a hardcoded 5) or it shows +0
    const limit = props?.userLength ? props?.userLength : 5;

    useScroll(document.getElementsByClassName('u_scroll-section')[1], (e) => {
        if (popupRef.current) popupRef.current.close();
    });

    return (
        <div className="u_project-view-assign">
            <div className="u_project-view-members u_more-users">
                {props?.members?.length !== 0 && props?.members?.map((data, i) => {
                    if (i < limit) return (
                        <div key={i}>
                            <UEmployeeInfo
                                size={props?.size ? props?.size : 24}
                                showName={false}
                                employee={_USERS[data]}
                                isSkeleton={!_USERS[data]}
                            />
                        </div>
                    );
                    else return '';
                })}
                {props?.members?.length !== 0 && props?.members?.length > limit &&
                    <Popup
                        ref={popupRef}
                        trigger={open => (
                            <div className={`u_more-users-btn ${open && 'u_active'} `}>
                                <span>+{props?.members.length - limit}</span>
                            </div>
                        )}
                        arrow={'center center'}
                        position="bottom right"
                        closeOnDocumentClick
                        repositionOnResize
                        keepTooltipInside={true}
                        contentStyle={{zIndex: 11111}}
                    >
                        <div className="u_popover u_w-200">
                            <ul className="u_more-member-popover u_scrollview u_scrollbar">
                                {props?.members && props?.members.map((data, i) => {
                                    if (i >= (props?.userLength ? props?.userLength : 5)) return <li key={i}>
                                        <UEmployeeInfo
                                            size={props?.size ? props?.size : 24}
                                            employee={_USERS[data]}
                                            isSkeleton={!_USERS[data]}
                                        />
                                    </li>;
                                    else return '';
                                })}
                            </ul>
                        </div>
                    </Popup>
                }
            </div>
        </div>
    );
});

export default MembersList;
